import {
    GET_AUTOMOBILE_VIN_INFORMATION,
    REMOVE_AUTOMOBILE_VIN_INFORMATION,
    UPDATE_AUTOMOBILE_VIN_RESULTS
} from '../../types';

const initialState = { VIN_Message: '' };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_AUTOMOBILE_VIN_INFORMATION:
            return {
                ...state,
                VIN_Results: { ...payload }
            };
        case UPDATE_AUTOMOBILE_VIN_RESULTS:
            return {
                ...state,
                VIN_Results: { ...payload }
            };
        case REMOVE_AUTOMOBILE_VIN_INFORMATION:
            return {
                ...state,
                VIN_InformationCount: 0,
                VIN_Message: '',
                VIN_Results: {},
                SearchCriteria: ''
            };

        default:
            return state;
    }
}